import React from 'react';
import { FiAward, FiShield, FiUserCheck } from 'react-icons/fi';

const Credentials = () => {
  const cards = [
    {
      icon: FiAward,
      title: "NNA Member",
      desc: "Active member of the National Notary Association, the largest professional notary organization in the country. Ongoing training and current best practices."
    },
    {
      icon: FiShield,
      title: "E&O Insurance",
      desc: "We carry Errors and Omissions insurance, professional liability coverage that protects you if a covered mistake occurs during a notarial act."
    },
    {
      icon: FiUserCheck,
      title: "Background Screened",
      desc: "Independently background-screened, the same standard title companies and lenders look for. You're working with a verified, vetted professional."
    }
  ];

  return (
    <section className="py-24 px-6 bg-navy text-cream">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-brass-light text-xs font-bold tracking-[0.2em] uppercase mb-4 block">CREDENTIALS AND PROTECTION</span>
          <h2 className="font-fraunces text-4xl md:text-5xl mb-6">
            You deserve to know <span className="italic text-brass-light">who's signing your documents.</span>
          </h2>
          <p className="text-lg text-cream/70">
            Here's what backs our work and protects you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {cards.map((card, i) => (
            <div key={i} className="flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-full border border-brass flex items-center justify-center text-brass mb-6">
                <card.icon size={28} />
              </div>
              <h3 className="font-fraunces text-2xl mb-4">{card.title}</h3>
              <p className="text-cream/60 leading-relaxed text-sm">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Credentials;